import React from 'react';
import Cell from './Cell';
import { Cell as CellType } from '../types';

interface NextPieceProps {
  shape: (string | number)[][];
  /** Optional size in pixels for width/height (default 100) */
  size?: number;
}

// Component to preview the next tetromino
const NextPiece: React.FC<NextPieceProps> = ({ shape, size }) => {
  const rows = shape.length;
  const cols = shape[0].length;
  const defaultSize = size ?? 100;
  // For smaller previews, use thinner border/padding
  const borderWidth = size ? Math.max(1, Math.round(defaultSize * 0.05)) : 4;
  const padding = borderWidth;
  const style: React.CSSProperties = {
    display: 'grid',
    gridTemplateRows: `repeat(${rows}, 1fr)`,
    gridTemplateColumns: `repeat(${cols}, 1fr)`,
    background: '#111',
    border: `${borderWidth}px solid #333`,
    borderRadius: '4px',
    boxSizing: 'border-box',
    width: `${defaultSize}px`,
    height: `${defaultSize}px`,
    padding: `${padding}px`,
  };
  return (
    <div style={style}>
      {shape.map((row, y) =>
        row.map((value, x) => {
          const cell: CellType = [value, 'clear'];
          return <Cell key={`${y}-${x}`} cell={cell} />;
        })
      )}
    </div>
  );
};

export default React.memo(NextPiece);